var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCommsDelay01 = function SvgCommsDelay01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "comms_delay-01_svg2__a",
    x1: 31.44,
    x2: 172.6,
    y1: 180.69,
    y2: 39.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#comms_delay-01_svg2__a",
    id: "comms_delay-01_svg2__b",
    x1: -1.3,
    x2: 139.87,
    y1: 147.95,
    y2: 6.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#comms_delay-01_svg2__a",
    id: "comms_delay-01_svg2__c",
    x1: 67.91,
    x2: 209.08,
    y1: 217.17,
    y2: 76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#comms_delay-01_svg2__a",
    id: "comms_delay-01_svg2__d",
    x1: 73.47,
    x2: 214.64,
    y1: 222.72,
    y2: 81.56
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M175.31 100.41h-1.38c.64-4.28.96-8.62.96-12.97 0-48.22-39.22-87.45-87.44-87.45S0 39.23 0 87.45s39.23 87.45 87.45 87.45c4.35 0 8.69-.33 12.97-.96v20.21c0 3.11 2.51 5.86 5.86 5.86 1.14 0 2.27-.33 3.25-.98l17.35-11.57h48.43c13.61 0 24.69-11.07 24.69-24.69v-37.66c0-13.61-11.07-24.69-24.69-24.69Zm-74.89 24.69v36.95c-4.26.74-8.61 1.11-12.97 1.11-41.76 0-75.73-33.97-75.73-75.73s33.97-75.71 75.73-75.71 75.73 33.97 75.73 75.73c0 4.36-.38 8.71-1.11 12.97h-36.96c-13.64 0-24.69 11.03-24.69 24.69Zm87.86 37.65c0 7.15-5.82 12.97-12.97 12.97H125.1c-1.16 0-2.29.34-3.25.98l-9.72 6.48v-58.09c0-7.17 5.8-12.97 12.97-12.97h50.21c7.15 0 12.97 5.82 12.97 12.97z",
    style: {
      fill: "url(#comms_delay-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.45 25.1c-3.24 0-5.86 2.62-5.86 5.86v50.63h-31.8c-3.24 0-5.86 2.62-5.86 5.86s2.62 5.86 5.86 5.86h37.66c3.23 0 5.86-2.62 5.86-5.86V30.96c0-3.24-2.62-5.86-5.86-5.86",
    style: {
      fill: "url(#comms_delay-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.81 129.77h-43c-2.21 0-4 1.79-4 4s1.79 4 4 4h43c2.21 0 4-1.79 4-4s-1.79-4-4-4",
    style: {
      fill: "url(#comms_delay-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.54 150.77h-22.23c-2.21 0-4 1.79-4 4s1.79 4 4 4h22.23c2.21 0 4-1.79 4-4s-1.79-4-4-4",
    style: {
      fill: "url(#comms_delay-01_svg2__d)"
    }
  }));
};
export default SvgCommsDelay01;